"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ListDropDown = _interopRequireWildcard(require("../ListDropDown/ListDropDown"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ListInput = function ListInput(_ref, ref) {
  var id = _ref.id,
      value = _ref.value,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      onSelect = _ref.onSelect,
      onBlur = _ref.onBlur,
      list = _ref.list,
      adjustable = _ref.adjustable,
      emptyListLabel = _ref.emptyListLabel;
  var inputRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        inputRef.current.focus();
      }
    };
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isListOpen = _useState2[0],
      setListOpen = _useState2[1];

  var filteredList = (0, _react.useMemo)(function () {
    return value === '' || list == null ? list : list.filter(function (c) {
      return c.name.toLowerCase().includes(value.toLowerCase()) || c.account.toLowerCase().includes(value.toLowerCase());
    });
  }, [value, list]);

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  (0, _react.useEffect)(function () {
    if (filteredList && focused >= filteredList.length && filteredList.length > 0) {
      setFocused(filteredList.length - 1);
    }
  }, [filteredList, focused]);

  var handleKeyDown = function handleKeyDown(e) {
    if (['Enter', 'Tab', ',', ';'].includes(e.key)) {
      if (e.key === 'Tab' && value === '') return;
      e.preventDefault();

      if (isListOpen && filteredList != null && filteredList[focused] !== undefined) {
        setListOpen(false);
        onSelect(filteredList[focused]);
      } else if (value !== '') {
        setListOpen(false);
        onSelect({
          account: value
        });
      }
    } else {
      if (filteredList != null) {
        if (!isListOpen) setListOpen(true);

        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
          e.preventDefault();
          if (e.key === 'ArrowDown') setFocused(Math.min(focused + 1, filteredList.length - 1));else if (e.key === 'ArrowUp') setFocused(Math.max(0, focused - 1));
        }
      }
    }
  };

  var selectRef = (0, _react.useRef)(onSelect);
  (0, _react.useEffect)(function () {
    selectRef.current = onSelect;
  });
  var blurCallback = (0, _react.useCallback)(function () {
    if (value !== '') {
      selectRef.current({
        account: value
      });
    } else {
      onBlur && onBlur();
    }
  }, [onBlur, value]);
  var blurFlag = (0, _react.useRef)(false);

  var handleBlur = function handleBlur() {
    if (filteredList == null) {
      blurCallback();
    } else {
      if (!(filteredList.length > 0 && isListOpen) && value !== '') {
        onSelect({
          account: value
        });
      }

      blurFlag.current = true;
    }
  };

  (0, _react.useEffect)(function () {
    if (blurFlag.current && !isListOpen) {
      blurCallback();
      blurFlag.current = false;
    }
  }, [isListOpen, blurCallback]);

  var handleItemClick = function handleItemClick(c) {
    setListOpen(false);
    onSelect(c);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    tabIndex: 1,
    onBlur: handleBlur,
    className: 'uin-ain-list-input' + (adjustable ? ' auto' : '')
  }, /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    type: "mail",
    style: adjustable ? {
      width: value.length * 0.875 + 'rem'
    } : undefined,
    value: value,
    onClick: onClick,
    onChange: onChange,
    onKeyDown: handleKeyDown,
    autoComplete: "off"
  }), filteredList && filteredList.length > 0 ? /*#__PURE__*/_react["default"].createElement(_ListDropDown["default"], {
    target: id,
    isOpen: isListOpen,
    toggle: function toggle() {
      return setListOpen(!isListOpen);
    }
  }, filteredList.map(function (c, i) {
    return /*#__PURE__*/_react["default"].createElement(_ListDropDown.ListItem, {
      key: i,
      icon: "user",
      username: c.name,
      extraUserInfo: c.account,
      onClick: function onClick() {
        return handleItemClick(c);
      },
      focused: focused === i,
      onFocus: function onFocus() {
        return setFocused(i);
      }
    });
  })) : (list == null || list.length === 0) && emptyListLabel && /*#__PURE__*/_react["default"].createElement(_ListDropDown["default"], {
    target: id,
    isOpen: isListOpen,
    toggle: function toggle() {
      return setListOpen(!isListOpen);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "empty-dd"
  }, emptyListLabel)));
};

var _default = /*#__PURE__*/(0, _react.forwardRef)(ListInput);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/AddressInput/ListInput.js
// module id = 689
// module chunks = 0